module.exports = __webpack_public_path__ + "img/information_message_of_love.4a39576.webp";